import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { modulesService } from '@/services'
import { episodesService } from '@/services/episodes.service'
import { useAuth } from '@/hooks'
import { toast } from 'sonner'

export const useModules = () => {
  return useQuery({
    queryKey: ['modules'],
    queryFn: modulesService.getAll,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useModule = (id: number) => {
  return useQuery({
    queryKey: ['modules', id],
    queryFn: () => modulesService.getById(id),
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
  })
}

// ✅ Atualizado para usar a nova API de episódios
export const useEpisode = (moduleId: number, episodeNumber: number) => {
  const { token } = useAuth()

  return useQuery({
    queryKey: ['episode', moduleId, episodeNumber],
    queryFn: () => episodesService.getEpisode(moduleId, episodeNumber, token || undefined),
    enabled: !!moduleId && !!episodeNumber,
    staleTime: 1000 * 60 * 5,
    retry: 1, // ✅ Reduz tentativas (antes era 3 por padrão)
  })
}

/**
 * Hook para atualizar progresso de um episódio
 */
export function useUpdateEpisodeProgress() {
  const { token } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      episodeId,
      data,
    }: {
      episodeId: number
      data: { completed?: boolean; watchedDuration?: number }
    }) => {
      if (!token) throw new Error('Usuário não autenticado')
      return episodesService.updateProgress(episodeId, data, token)
    },
    onSuccess: () => {
      // Invalida queries de episódios para atualizar progresso
      queryClient.invalidateQueries({ queryKey: ['episode'] })
      queryClient.invalidateQueries({ queryKey: ['next-episode'] })
    },
    onError: (error: Error) => {
      console.error('Erro ao atualizar progresso:', error.message)
    },
  })
}
